import { Codebook } from './codebook';

export class Codebooks {
  paymentSources: Codebook[];
  paymentModes: Codebook[];
  paymentFrequency: Codebook[];
}

declare global {
  interface Array<T> {
    findById(id: number): T;
  }
}

Array.prototype.findById = function(id: number): any {
    return this.find(x => x?.id === id);
  };
